import { useColorSchemeValue } from "@hopper-ui/components";
import {
    FullScreenHomeAuthenticatedLayout,
    type FullScreenHomeAuthenticatedLayoutProps
} from "../../components/FullScreenHomeAuthenticatedLayout.tsx";
import { partnerTierStripeColors } from "./partnerTierStripeColors.ts";
import { PartnerWorkspaceGate } from "./PartnerWorkspaceGate.tsx";
import { usePartnerTier } from "./usePartnerTier.ts";

export type PartnerLayoutProps = Omit<FullScreenHomeAuthenticatedLayoutProps, "accentColor" | "mainContent">;

export const PartnerLayout = (props: PartnerLayoutProps) => {
    const partnerTier = usePartnerTier();
    const stripeColor = useColorSchemeValue(
        partnerTier ? partnerTierStripeColors[partnerTier].light : "",
        partnerTier ? partnerTierStripeColors[partnerTier].dark : ""
    );

    return (
        <FullScreenHomeAuthenticatedLayout
            {...props}
            accentColor={partnerTier ? stripeColor : undefined}
            mainContent={<PartnerWorkspaceGate />}
        />
    );
};
